import React from 'react';

const UserOutcomesContext = React.createContext({
  outcomes: [],
  goals: [],
  reloadOutcomes: () => null,
  recommendedOutcomes: [],
  reloadRecommendations: () => null,
  outcomes_loading: false,
});

export default UserOutcomesContext;
